import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
// export function getAssetPath(relativePath: string): string {
//   const currentDir = dirname(fileURLToPath(import.meta.url));
//   return join(currentDir, "..", "assests", relativePath);
// }
//# sourceMappingURL=utils.js.map